// This config specifies which providers can we use according to the privacy policy.
// Before sending data to a provider, the code must check this config, and throw an error if the provider is not enabled.
//
// Any service enabled here must be added to:
// src/modules/static/privacy-policy.md - in Section 13. Recipients and Processors
//
export const providerConfig = {
  // Server hosted on Hetzner, no code
  hetzner: {
    enabled: true,
  },
  // Stripe is used for payments and billing
  stripe: {
    enabled: true,
  },
  // Scaleway Transactional Email API for outbound mail
  scaleway: {
    enabled: true,
    hosts: ["api.scaleway.com"],
  },
  // Plausible is used for privacy-focused analytics
  plausible: {
    enabled: true,
  },
  openai: {
    enabled: true,
  },
  // Mistral is used for dictionary word lookups (OpenAI-compatible chat API).
  mistral: {
    enabled: false,
    hosts: ["api.mistral.ai"],
  },
  // Deepgram is used for speech-to-text
  deepgram: {
    enabled: true,
    hosts: ["api.eu.deepgram.com"],
  },
  // Deepl is used for machine translation
  deepl: {
    enabled: true,
    // Pro uses api.deepl.com; free-tier keys (`:fx`) use api-free.deepl.com (see DeeplTranslator).
    hosts: ["api.deepl.com", "api-free.deepl.com"],
  },
  // Google Cloud is used for machine translation
  googlecloud: {
    enabled: true,
    hosts: ["translate-eu.googleapis.com"],
  },
  // Cloudflare Turnstile protects the login form from automated abuse.
  cloudflare: {
    enabled: true,
    hosts: ["challenges.cloudflare.com"],
  },
};
